/* eslint-disable @typescript-eslint/interface-name-prefix */
// 案例分析-info

import { ParseQuestionI, QuestionI, StuParseQuestionI } from '../question/js/interface';

/**
 * @param id: string;
 * @param jobName: 案例分析名字;
 * @param jobKnowledge: 知识体系;
 * @param jobInfomation: 案例详情-富文本;
 */
export interface JobBasicInfoI {
  id: string;
  jobName: string;
  jobKnowledge: string;
  jobInfomation: string;
}
export class ClassJobBasicInfoI implements JobBasicInfoI {
  id = ''

  jobName = ''

  jobKnowledge = ''

  jobInfomation = ''
}

/**
 * 案例分析-题目模块
 * @param id 模块id
 * @param jobModuleName 模块名
 */
export interface JobModuleI {
  id: string;
  jobModuleName: string;
}

/**
 * @param questionList 问题列表——解密后的
 */
export interface IJobModuleQuestionParse extends JobModuleI {
  questionList: ParseQuestionI[];
  seq: number;
}
/**
 * @param questionList 问题列表——解密后的——stu学生答题
 */
export interface IJobModuleQuestionParseStu extends JobModuleI {
  questionList: StuParseQuestionI[];
  seq: number;
}
/**
 * @param questionList 没揭秘的questionlist——api返回的
 */
export interface IJobModuleQuestionJson extends JobModuleI {
  questionList: QuestionI[];
  seq: number;
}
